export const ROOT_ROUTE = '/budget';

export const CONFIG = [
	{
		path: `${ROOT_ROUTE}/overview`,
		name: 'overview',
		label: 'Budget & Spend Overview',
		includePath: `${ROOT_ROUTE}/performance`,
	},
	{
		path: `${ROOT_ROUTE}/table`,
		name: 'table',
		label: 'Budget table',
	},
	{
		path: `${ROOT_ROUTE}/performance`,
		name: 'performance',
		label: 'Budget Performance',
		hideTab: true,
	},
];
